import React, { useEffect, useState } from 'react';
import { getUser, resolveUserDisplayLabel } from '../../services/user';
import './user.css';
import { IUser } from '@elyx-code/definitions';

type UserChipProps = {
	user: IUser | { id: string } | { email: string };
	labelStyles?: React.CSSProperties;
}

const UserChip: React.FC<UserChipProps> = (props) => {
	const labelStyles = props.labelStyles || {};

	const [user, setUser] = useState<IUser | null>(null);
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const getData = async () => {
		const hasOnlyIdentifier = Object.keys(props).length === 1;

		if (hasOnlyIdentifier) {
			setIsLoading(true);
			const user = await getUser(props.user);

			if (user) {
				setUser(user);
			}
		} else {
			setUser(props.user as IUser);
		}

		setIsLoading(false);
	};

	useEffect(() => {
		getData();
	}, []);

	return (
		<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
			<div className='small-user-avatar'>
				{user?.picture ? (
					<img
						src={user.picture}
						title={`${user?.name} ${user?.lastName}`}
						alt='User Avatar'
					/>
				) : (
					<i
						className='fa-solid fa-user'
						title={`${user?.name} ${user?.lastName}`}
						style={{ fontSize: '14px' }}
					></i>
				)}
			</div>
			<p style={{ margin: '0px', color: 'rgba(0,0,0,0.54)', fontSize: '14px', ...labelStyles }}>
				{resolveUserDisplayLabel(user, isLoading ? '' : 'Account deleted')}
			</p>
		</div>
	);
};

export default UserChip;
